export const MESSAGE_PLACEHOLDER = 'Ask agent anything...'
export const NOTE_PLACEHOLDER = 'Add a note for your team...'
export const DEFAULT_MAX_HEIGHT = 200
export const MIN_HEIGHT = 44

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024

export const MAX_ATTACHMENTS = 5

const ACCEPTED_FILE_TYPE_LIST = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  '.pdf',
  'text/*',
  '.json',
  '.xml',
  '.yaml',
  '.yml',
  '.sql',
  '.md',
  '.txt',
  '.csv',
  '.html',
  '.css',
  '.js',
  '.ts',
  '.tsx',
  '.jsx',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
]

export const ACCEPTED_FILE_TYPES = ACCEPTED_FILE_TYPE_LIST.join(',')

export const SUPPORTED_IMAGE_MIME_TYPE_LIST = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
] as const

export const SUPPORTED_MIME_TYPE_LIST = [
  ...SUPPORTED_IMAGE_MIME_TYPE_LIST,
  'application/pdf',
  'application/json',
  'application/xml',
  'application/x-yaml',
  'application/sql',
  'text/plain',
  'text/csv',
  'text/markdown',
  'text/xml',
  'text/yaml',
  'text/html',
  'text/css',
  'text/javascript',
  'text/x-sql',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
] as const

export const SUPPORTED_EXTENSIONS_FALLBACK_MAP: Record<string, boolean> = {
  '.pdf': true,
  '.json': true,
  '.xml': true,
  '.yaml': true,
  '.yml': true,
  '.sql': true,
  '.txt': true,
  '.csv': true,
  '.md': true,
  '.html': true,
  '.css': true,
  '.js': true,
  '.ts': true,
  '.tsx': true,
  '.jsx': true,
  '.doc': true,
  '.docx': true,
  '.xls': true,
  '.xlsx': true,
  '.ppt': true,
  '.pptx': true,
}
